import { useLocation, useNavigate } from 'react-router-dom';
import './WalkerBottomNav.css';

/**
 * The single bottom nav for the walker-facing flow (feed, journey, map,
 * settings). Previously each of those four screens carried its own copy of
 * this markup plus its own CSS block, which is how the emoji icons and the
 * orange active state drifted out of sync. There is intentionally only ONE
 * walker nav — add items here, not per screen.
 *
 * The active item is derived from the current route, so callers pass nothing.
 */

// Thin line-stroke icons, matching the compass mark on the welcome screen.
const ICONS = {
  deals: (
    <>
      <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </>
  ),
  journey: (
    <>
      <polygon points="1 6 8 3 16 6 23 3 23 18 16 21 8 18 1 21 1 6" />
      <line x1="8" y1="3" x2="8" y2="18" />
      <line x1="16" y1="6" x2="16" y2="21" />
    </>
  ),
  map: (
    <>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </>
  ),
};

const NAV_ITEMS = [
  { icon: 'deals',    label: 'Deals',        path: '/feed'     },
  { icon: 'journey',  label: 'Journey',      path: '/journey'  },
  { icon: 'map',      label: 'Kaart',        path: '/map'      },
  { icon: 'settings', label: 'Instellingen', path: '/settings' },
];

export default function WalkerBottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="walker-nav">
      {NAV_ITEMS.map((item) => (
        <button
          key={item.label}
          className={`walker-nav__item${pathname === item.path ? ' walker-nav__item--active' : ''}`}
          onClick={() => navigate(item.path)}
          aria-current={pathname === item.path ? 'page' : undefined}
        >
          <svg
            className="walker-nav__icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            {ICONS[item.icon]}
          </svg>
          <span className="walker-nav__label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
